import { Button } from '@progress/kendo-react-buttons';
import { DATASET_INITIAL_ID } from '../../constants';
import { PropsWithChildren, useCallback } from 'react';
import { useCompareUrlWithProjectId, useNavigateWithProjectId } from '../../hooks/route';
import { ElsieAISummaryButton } from '../elsieAISummary/ElsieAISummaryButton';

import useNavigationMenus from 'common/hooks/useMenus';
import { DEVELOPMENT_ROUTES } from 'routes/routes.const';
import CreateDashboardButton from './CreateDashboardButton';
import ListsNavButton from '../planningNavButtons/ListsNavButton';
import CollectionsNavButton from '../planningNavButtons/CollectionsNavButton';
import DownloadNavButton from '../planningNavButtons/DownloadNavButton';
import PowerPointPageExportButton from './PowerPointPageExportButton';
import DevelopmentButton from 'modules/insights/components/DevelopmentButton';

export function PageTabs({ children }: Readonly<PropsWithChildren>) {
  const navigate = useNavigateWithProjectId();
  const { tabMenuItems } = useNavigationMenus();
  const { compareUrl } = useCompareUrlWithProjectId();

  const handleItemNavigation = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  // Don't show page tabs bar for development routes
  if (compareUrl(DEVELOPMENT_ROUTES.root, { includes: true })) {
    return children;
  }

  return (
    <div className="page-tabs">
      {Array.isArray(tabMenuItems) && (
        <div className="page-tab-toolbar">
          <div className="page-tab-buttons">
            {tabMenuItems.map((tab) => (
              <Button
                key={tab.text}
                className={
                  compareUrl(tab.route as string, { includes: true }) ? 'page-tabs-active' : ''
                }
                onClick={() => handleItemNavigation(tab.route as string)}
                fillMode="flat"
                size={'large'}
                rounded={null}
              >
                {tab.text}
              </Button>
            ))}
          </div>
          <div className="right">
            <DevelopmentButton />
            <ElsieAISummaryButton />
            <ListsNavButton />
            <CollectionsNavButton />
            <DownloadNavButton />
            <PowerPointPageExportButton />
            <CreateDashboardButton datasetId={DATASET_INITIAL_ID} />
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
